import { PropertiesContainer } from '@/modules/Properties';

const Properties = (): JSX.Element => <PropertiesContainer />;

export default Properties;
